
import Vue from 'vue';
import Component from 'vue-class-component';
import { getModule } from 'vuex-module-decorators';
import Transcription from '@/store/modules/transcription';
import store from '@/store/store';
import { Watch, Prop } from 'vue-property-decorator';
import { ITranscriptionHistory } from '../../types';
import DiffDialog from './DiffDialog.vue';
import LikeButton from '../atoms/LikeButton.vue';
import { db } from '../../plugins/firebase';
import LikeCount from '../atoms/LikeCount.vue';
import Auth from '@/store/modules/auth';
import UserName from '@/components/atoms/UserName.vue';

const trscModule = getModule(Transcription, store);
const authModule = getModule(Auth, store);

@Component({ components: { LikeButton, LikeCount, UserName } })
export default class TrscHistoryEntry extends Vue {
  @Prop(Object) entry!: ITranscriptionHistory;
  @Prop(Object) previous!: ITranscriptionHistory;
  user = {};
  likers = this.entry.likers || {};

  get currentUser() {
    return authModule.user;
  }

  async mounted() {
    this.user = await this.$db.getUserData(this.entry.uid);
  }

  async toggleLike(uid: string, value: boolean) {
    this.$set(this.likers, uid, value);
    const update = {};
    update[`likers.${uid}`] = value;
    const res = await db
      .collection('transcriptions')
      .doc(this.entry.transcriptionId)
      .collection('history')
      .doc(this.entry.id)
      .update(update);
  }
}
